import { __extends } from "tslib";
import { NodeBase } from '@awayjs/view';
/**
 * Maintains scenegraph heirarchy when collecting nodes
 */
var SceneGraphNode = /** @class */ (function (_super) {
    __extends(SceneGraphNode, _super);
    function SceneGraphNode() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._enitityIDsToNodes = {};
        return _this;
    }
    /**
     *
     * @param traverser
     */
    SceneGraphNode.prototype.acceptTraverser = function (traverser) {
        if (this._partition.root == this._entity)
            this._partition.updateEntities();
        //get the sub-traverser for the partition, if different, terminate this traversal
        if (traverser.partition != this._partition && traverser != traverser.getTraverser(this._partition))
            return;
        if (!traverser.enterNode(this))
            return;
        var i;
        var len = this._entity._children.length;
        for (i = len - 1; i >= 0; i--)
            this._enitityIDsToNodes[this._entity._children[i].id].acceptTraverser(traverser);
        if (this._graphicsNode) {
            this._graphicsNode.acceptTraverser(traverser);
        }
    };
    /**
     *
     * @param node
     * @internal
     */
    SceneGraphNode.prototype.iAddNode = function (node) {
        node.parent = this;
        if (this._entity == node.entity) {
            this._graphicsNode = node;
        }
        else {
            this._enitityIDsToNodes[node.entity.id] = node;
        }
    };
    SceneGraphNode.prototype.isVisible = function () {
        return this._entity._iIsVisible();
    };
    /**
     *
     * @param node
     * @internal
     */
    SceneGraphNode.prototype.iRemoveNode = function (node) {
        if (this._graphicsNode == node) {
            this._graphicsNode = null;
        }
        else {
            delete this._enitityIDsToNodes[node.entity.id];
        }
    };
    return SceneGraphNode;
}(NodeBase));
export { SceneGraphNode };
